import React from "react"
import {useEthers} from "@usedapp/core"

import {usePools} from './hooks'
import styles from './styles'
import {uniswapLogo} from './assets'
import { Exchange, Loader,WalletButton } from "./componets"

const App = () => {
  const {account} = useEthers();
  const [loading, pools] = usePools();


  return(
    <div className={styles.container}>
    <div className={styles.innerContainer} >
      <header  className={styles.header}>
        <img src={uniswapLogo} alt="uniswap logo"
        className="w-16 h-16 object-contain" />
        <WalletButton/>
      </header>
      <div className={styles.exchangeContainer} >
        <h1 className={styles.headTitle}>Cryptos</h1>
        <p className={styles.subTitle} >Обмен токенами</p>
        <div className={styles.exchangeBoxWrapper}>
          <div className={styles.exchangeBox}>
            <div className="blue_gradient"></div>
            <div className={styles.exchange}>
                {account?(
                  loading ?(
                    <Loader title="Загрузка, подождите"/>
                  ) : <Exchange  pools={pools}/>
                ) : <Loader title="Подключите свой кошелек"/>}
            </div>
            <div className="pink_gradient"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default App; 